import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';

export default function Logs() {
  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');

  useEffect(() => { fetchLogs(); }, []);

  const fetchLogs = async () => {
    setLoading(true);
    const { data } = await supabase
      .from('app_logs')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(200);
    if (data) setLogs(data);
    setLoading(false);
  };

  const clearLogs = async () => {
    if (!window.confirm('Очистить все логи?')) return;
    await supabase.from('app_logs').delete().neq('id', 0);
    fetchLogs();
  };

  const formatDate = (d: string) => new Date(d).toLocaleString('ru-RU');

  const filtered = logs.filter(l => {
    const matchFilter = filter === 'all' || l.type === filter;
    const matchSearch = l.message?.toLowerCase().includes(search.toLowerCase()) ||
      l.user_id?.toLowerCase().includes(search.toLowerCase());
    return matchFilter && matchSearch;
  });

  const typeColor = (type: string) => {
    if (type === 'error') return { bg: '#fdecea', color: '#e74c3c' };
    if (type === 'warning') return { bg: '#fef9e7', color: '#f39c12' };
    return { bg: '#f0faf4', color: '#2ECC71' };
  };

  const counts = {
    error: logs.filter(l => l.type === 'error').length,
    warning: logs.filter(l => l.type === 'warning').length,
    info: logs.filter(l => l.type === 'info').length,
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={s.title}>📋 Логи системы</h1>
        <div style={{ display: 'flex', gap: 10 }}>
          <button style={s.btnRefresh} onClick={fetchLogs}>🔄 Обновить</button>
          <button style={s.btnClear} onClick={clearLogs}>🗑️ Очистить</button>
        </div>
      </div>

      <div style={s.statsRow}>
        <div style={{ ...s.statCard, borderColor: '#e74c3c' }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#e74c3c' }}>{counts.error}</div>
          <div style={s.statLabel}>Ошибки</div>
        </div>
        <div style={{ ...s.statCard, borderColor: '#f39c12' }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#f39c12' }}>{counts.warning}</div>
          <div style={s.statLabel}>Предупреждения</div>
        </div>
        <div style={{ ...s.statCard, borderColor: '#2ECC71' }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#2ECC71' }}>{counts.info}</div>
          <div style={s.statLabel}>Информация</div>
        </div>
      </div>

      <div style={s.toolbar}>
        <input style={s.search} placeholder="Поиск по сообщению или пользователю..." value={search} onChange={e => setSearch(e.target.value)} />
        <select style={s.select} value={filter} onChange={e => setFilter(e.target.value)}>
          <option value="all">Все типы</option>
          <option value="error">Ошибки</option>
          <option value="warning">Предупреждения</option>
          <option value="info">Информация</option>
        </select>
      </div>

      {loading ? <p>Загрузка...</p> : filtered.length === 0 ? (
        <div style={s.empty}>Логов нет</div>
      ) : (
        <div style={s.logList}>
          {filtered.map(log => {
            const tc = typeColor(log.type);
            return (
              <div key={log.id} style={s.logItem}>
                <div style={s.logHeader}>
                  <span style={{ ...s.badge, backgroundColor: tc.bg, color: tc.color }}>
                    {log.type === 'error' ? '❌' : log.type === 'warning' ? '⚠️' : 'ℹ️'} {log.type}
                  </span>
                  <span style={s.logDate}>{formatDate(log.created_at)}</span>
                  {log.user_id && <span style={s.logUser}>👤 {log.user_id.substring(0, 8)}...</span>}
                </div>
                <div style={s.logMessage}>{log.message}</div>
                {log.details && (
                  <pre style={s.logDetails}>{JSON.stringify(log.details, null, 2)}</pre>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  title: { fontSize: 24, fontWeight: 700, color: '#222', margin: 0 },
  statsRow: { display: 'flex', gap: 16, marginBottom: 24 },
  statCard: { backgroundColor: '#fff', borderRadius: 12, padding: 20, flex: 1, textAlign: 'center', borderWidth: 2, borderStyle: 'solid' },
  statLabel: { fontSize: 13, color: '#888', marginTop: 4 },
  toolbar: { display: 'flex', gap: 12, marginBottom: 16 },
  search: { padding: '10px 14px', borderRadius: 8, border: '1px solid #eee', fontSize: 14, width: 360, outline: 'none' },
  select: { padding: '10px 14px', borderRadius: 8, border: '1px solid #eee', fontSize: 14, outline: 'none' },
  empty: { textAlign: 'center', color: '#aaa', padding: 40, backgroundColor: '#fff', borderRadius: 12 },
  logList: { display: 'flex', flexDirection: 'column', gap: 8 },
  logItem: { backgroundColor: '#fff', borderRadius: 10, padding: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  logHeader: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 },
  badge: { padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 500 },
  logDate: { fontSize: 12, color: '#aaa' },
  logUser: { fontSize: 12, color: '#888' },
  logMessage: { fontSize: 14, color: '#222', lineHeight: 1.5 },
  logDetails: { backgroundColor: '#f5f5f5', borderRadius: 6, padding: 10, fontSize: 12, color: '#555', marginTop: 8, overflow: 'auto', maxHeight: 150 },
  btnRefresh: { padding: '8px 16px', backgroundColor: '#3498db', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13 },
  btnClear: { padding: '8px 16px', backgroundColor: '#e74c3c', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13 },
};